/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ProductStockAvailability
 */
export interface ProductStockAvailability {
    /**
     *
     * @type {number}
     * @memberof ProductStockAvailability
     */
    requestedQuantity: number;
    /**
     *
     * @type {number}
     * @memberof ProductStockAvailability
     */
    fulfillableQuantity: number;
    /**
     *
     * @type {number}
     * @memberof ProductStockAvailability
     */
    availableContentsQuantity: number;
    /**
     *
     * @type {number}
     * @memberof ProductStockAvailability
     */
    caseContentsQuantity: number;
}

/**
 * Check if a given object implements the ProductStockAvailability interface.
 */
export function instanceOfProductStockAvailability(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "requestedQuantity" in value;
    isInstance = isInstance && "fulfillableQuantity" in value;
    isInstance = isInstance && "availableContentsQuantity" in value;
    isInstance = isInstance && "caseContentsQuantity" in value;

    return isInstance;
}

export function ProductStockAvailabilityFromJSON(json: any): ProductStockAvailability {
    return ProductStockAvailabilityFromJSONTyped(json, false);
}

export function ProductStockAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductStockAvailability {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'requestedQuantity': json['requested_quantity'],
        'fulfillableQuantity': json['fulfillable_quantity'],
        'availableContentsQuantity': json['available_contents_quantity'],
        'caseContentsQuantity': json['case_contents_quantity'],
    };
}

export function ProductStockAvailabilityToJSON(value?: ProductStockAvailability | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'requested_quantity': value.requestedQuantity,
        'fulfillable_quantity': value.fulfillableQuantity,
        'available_contents_quantity': value.availableContentsQuantity,
        'case_contents_quantity': value.caseContentsQuantity,
    };
}

